import { BLACK_d } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 16.8rem;
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 60rem;
  & > img {
    width: 192rem;
    height: 60rem;
    position: absolute;
    top: 0;

    background: #000000;
    opacity: 0.6;
    z-index: -999;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    height: 47.6rem;
    width: 100vw;
    margin-left: -20px;
    padding-left: 20px;
    padding-right: 20px;
    overflow-x: hidden;
    & > img {
      width: 152rem;
      height: 47.6rem;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 17rem;
  margin-left: 47rem;
  & > span {
    &:nth-child(1) {
      font-weight: 700;
      font-size: 4rem;
      line-height: 7rem;
    }
    &:nth-child(2) {
      font-weight: 300;
      font-size: 2rem;
      line-height: 3.6rem;
      color: ${BLACK_d};
    }

    display: flex;
    flex-direction: column;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 8rem;
    margin-left: 0rem;
    & > span {
      &:nth-child(1) {
        font-size: 3.2rem;
        line-height: 5.4rem;
      }
      &:nth-child(2) {
        font-size: 1.6rem;
        line-height: 2.8rem;
      }
    }
  }
`;
